import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg"><g fillRule="evenodd" clipRule="evenodd" fill="#fff"><path d="M6 12.75a.75.75 0 010-1.5h12a.75.75 0 010 1.5H6z" /><path d="M12.97 8.03a.75.75 0 111.06-1.06l4.5 4.5a.75.75 0 010 1.06l-4.5 4.5a.75.75 0 01-1.06-1.06L16.94 12l-3.97-3.97z" /></g></svg>;
}
export default SvgComponent;